const shadow = 'rgba(0, 0, 0, .1)';
const shadowDark = 'rgba(0, 0, 0, .14)';
export const Elevations = {
  elevation: "0px 2px 2px ".concat(shadow),
  elevation_hover: "0 2px 4px -1px ".concat(shadow, ",0 4px 5px 0 ").concat(shadowDark, ",0 1px 10px 0 ").concat(shadowDark)
};